import { resolveMediaUrl } from './mediaUrl';

const getSection = (page, key) => page?.sections?.find((section) => section.key === key) || null;

const getMediaUrl = (section, groupKey) => {
  const media =
    section?.media?.groups?.[groupKey]?.[0] ||
    (groupKey === 'hero-image' || groupKey === 'feature-image' ? section?.media?.primary : null);

  return media?.url ? resolveMediaUrl(media.url) : '';
};

export const parsePlatformsHeroContent = (page) => {
  const section = getSection(page, 'hero');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    eyebrow: fields.eyebrow || '',
    title: fields.title,
    text: fields.text || '',
    cta: {
      text: fields.ctaText || '',
      url: fields.ctaUrl || '/contact',
    },
    image: getMediaUrl(section, 'hero-image'),
  };
};

export const parsePlatformsDidContent = (page) => {
  const section = getSection(page, 'did');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const items = [];

  for (let index = 1; index <= 10; index += 1) {
    const title = fields[`item-${index}-title`];
    if (!title) {
      break;
    }

    items.push({
      title,
      text: fields[`item-${index}-text`] || '',
      icon: getMediaUrl(section, `item-${index}-icon`),
    });
  }

  if (items.length === 0) {
    return null;
  }

  return { items };
};

export const parsePlatformsEngineeredContent = (page) => {
  const section = getSection(page, 'engineered');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  const features = [];

  for (let index = 1; index <= 10; index += 1) {
    const title = fields[`feature-${index}-title`];
    if (!title) {
      break;
    }

    features.push({
      title,
      text: fields[`feature-${index}-text`] || '',
    });
  }

  if (features.length === 0) {
    return null;
  }

  return {
    title: fields.title,
    features,
  };
};

export const parsePlatformsMetaTraderContent = (page) => {
  const section = getSection(page, 'metatrader');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  const downloads = [];

  for (let index = 1; index <= 10; index += 1) {
    const label = fields[`download-${index}-label`];
    if (!label) {
      break;
    }

    downloads.push({
      label,
      href: fields[`download-${index}-url`] || '#',
      icon: getMediaUrl(section, `download-${index}-icon`),
    });
  }

  return {
    title: fields.title,
    text: fields.text || '',
    image: getMediaUrl(section, 'feature-image'),
    downloads,
  };
};

export const parsePlatformsEntryPointsContent = (page) => {
  const section = getSection(page, 'entry-points');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    title: fields.title,
    text: fields.text || '',
    icon: getMediaUrl(section, 'feature-icon'),
  };
};

export const parsePlatformsAwaitsContent = (page) => {
  const section = getSection(page, 'awaits');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    title: fields.title,
    text: fields.text || '',
    cta: {
      text: fields.ctaText || '',
      url: fields.ctaUrl || '/create-account',
    },
  };
};
